import { render, staticRenderFns } from "./ActVerification.vue?vue&type=template&id=1b8004cc&scoped=true&"
import script from "./ActVerification.vue?vue&type=script&async=true&lang=js&"
export * from "./ActVerification.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ActVerification.vue?vue&type=style&index=0&id=1b8004cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8004cc",
  null
  
)

export default component.exports